module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "video-search-dialog",
    attrs: {
      "title": "Historical lookup",
      "visible": _vm.visible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$emit('update:visible', $event)
      }
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "disabled": _vm.loading
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "table",
    attrs: {
      "data": _vm.tableData,
      "default-sort": {
        prop: 'startTime',
        order: 'ascending'
      },
      "row-key": "id",
      "height": "600",
      "expand-row-keys": _vm.selectedIds
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channelName",
      "label": "Channel",
      "filters": _vm.channelFilters,
      "filter-method": _vm.filterByChannel
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startTime",
      "label": "Start Time",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var ref_row = ref.row;
        var id = ref_row.id;
        var startTime = ref_row.startTime;

        return [_vm._v("\n                " + _vm._s(startTime.format('YYYY-MM-DD HH:mm:ss')) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endTime",
      "label": "End Time",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var ref_row = ref.row;
        var id = ref_row.id;
        var endTime = ref_row.endTime;

        return [_vm._v("\n                " + _vm._s(endTime.format('YYYY-MM-DD HH:mm:ss')) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var ref_row = ref.row;
        var id = ref_row.id;
        var startTime = ref_row.startTime;
        var endTime = ref_row.endTime;

        return [(_vm.selected[id]) ? [_c('TimeRangeSlider', {
          attrs: {
            "min": startTime,
            "max": endTime,
            "step": 10
          },
          model: {
            value: (_vm.selected[id].timeRange),
            callback: function($$v) {
              _vm.$set(_vm.selected[id], "timeRange", $$v)
            },
            expression: "selected[id].timeRange"
          }
        })] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.downloadDisabled,
      "loading": _vm.downloading
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("\n            Download\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b8def9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/devices/VideoSearchDialog.vue
// module id = 1142
// module chunks = 2